import { render, staticRenderFns } from "./SlideshowSliderAlt.vue?vue&type=template&id=d0ed656a&scoped=true&"
import script from "./SlideshowSliderAlt.vue?vue&type=script&lang=js&"
export * from "./SlideshowSliderAlt.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowSliderAlt.vue?vue&type=style&index=0&id=d0ed656a&lang=scss&scoped=true&"
import style1 from "./SlideshowSliderAlt.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ed656a",
  null
  
)

export default component.exports